import { createAuth0 } from "@auth0/auth0-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faPowerOff, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "highlight.js/styles/github.css";
import { createApp } from "vue";
import hljs from "vue3-highlightjs";
import { clientId as client_id, domain } from "../auth_config.json";
import App from "./App.vue";
import { createRouter } from "./router";

const app = createApp(App);

library.add(faLink, faUser, faPowerOff);

app
  .use(hljs)
  .use(createRouter(app))
  .use(
    createAuth0({
      domain,
      client_id,
      redirect_uri: window.location.origin,
    })
  )
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
